import type { Group } from 'three';

import { extractFbxMaterialColors } from './extractFbxMaterialColors';
import {
  extractFbxUpAxisMetadata,
  type FbxUpAxisMetadata,
} from './fbxAxisSystem';
import {
  type FbxMaterialCorrectionResult,
  correctFbxMaterials,
} from './fbxMaterialCorrection';

export interface PreparedCartographerFbxSceneResult
  extends FbxMaterialCorrectionResult {
  upAxisMetadata: FbxUpAxisMetadata | null;
}

/**
 * Applies Cartographer's FBX material recovery pass before the scene is cloned
 * or mounted in a preview so all Cartographer surfaces render the same result.
 */
export async function prepareCartographerFbxScene(
  scene: Group,
  buffer: ArrayBuffer,
): Promise<PreparedCartographerFbxSceneResult> {
  const extractedData = extractFbxMaterialColors(buffer);
  const correctionResult = await correctFbxMaterials(scene, extractedData);
  return {
    ...correctionResult,
    upAxisMetadata: extractFbxUpAxisMetadata(buffer),
  };
}
